import { axiosInstance } from "@/api/apiClient";
import {
  UserVerificationApi,
  UserVerificationApiUsersViewsNinjaUserVerificationCompleteVerificationByThirdPartyRequest,
  UserVerificationApiUsersViewsNinjaUserVerificationConfirmVerificationOtpRequest,
  UserVerificationApiUsersViewsNinjaUserVerificationDelegateVerificationToThirdPartyRequest,
  UserVerificationApiUsersViewsNinjaUserVerificationGeneratePresignedUploadUrlForVerificationDocumentRequest,
  UserVerificationApiUsersViewsNinjaUserVerificationRequestUserVerificationRequest,
  UserVerificationApiUsersViewsNinjaUserVerificationUploadVerificationDocumentByThirdPartyRequest,
  UserVerificationApiUsersViewsNinjaUserVerificationUploadVerificationDocumentRequest,
} from "@/api/client";
import { CustomAxiosRequestConfig } from "@/api/types";
import { BASE_API } from "@/helpers/constants";
import { AxiosResponse } from "axios";

const api = new UserVerificationApi(undefined, BASE_API, axiosInstance);

export const delegateVerificationToThirdParty = async (
  payload: UserVerificationApiUsersViewsNinjaUserVerificationDelegateVerificationToThirdPartyRequest
) => {
  return api.usersViewsNinjaUserVerificationDelegateVerificationToThirdParty.bind(
    api
  )(payload);
};

export type UserVerificationResponse = {
  data:
    | string
    | {
        token: string;
      };
  message?: string;
};

export const requestUserVerification = async (
  payload: UserVerificationApiUsersViewsNinjaUserVerificationRequestUserVerificationRequest
) => {
  return api.usersViewsNinjaUserVerificationRequestUserVerification.bind(api)(
    payload
  ) as unknown as Promise<AxiosResponse<UserVerificationResponse>>;
};

export type CompleteVerificationByThirdPartyResponse = UserVerificationResponse;

export const completeVerificationByThirdParty = async (
  payload: UserVerificationApiUsersViewsNinjaUserVerificationCompleteVerificationByThirdPartyRequest
) => {
  return api.usersViewsNinjaUserVerificationCompleteVerificationByThirdParty.bind(
    api
  )(payload, {
    accessLevel: "public",
  } as CustomAxiosRequestConfig) as unknown as Promise<
    AxiosResponse<CompleteVerificationByThirdPartyResponse>
  >;
};

export const confirmVerificationOtp = async (
  payload: UserVerificationApiUsersViewsNinjaUserVerificationConfirmVerificationOtpRequest
) => {
  return api.usersViewsNinjaUserVerificationConfirmVerificationOtp.bind(api)(
    payload
  );
};

export const getUserVerification = async () => {
  return api.usersViewsNinjaUserVerificationGetUserVerification.bind(api)();
};

export type GeneratePresignedUploadUrlResponse = {
  data: {
    upload_url: string;
    download_url: string;
  };
};

export const generatePresignedUploadUrl = async (
  payload: UserVerificationApiUsersViewsNinjaUserVerificationGeneratePresignedUploadUrlForVerificationDocumentRequest
) => {
  return api.usersViewsNinjaUserVerificationGeneratePresignedUploadUrlForVerificationDocument.bind(
    api
  )(payload) as unknown as Promise<
    AxiosResponse<GeneratePresignedUploadUrlResponse>
  >;
};

export type GetRemainingVerificationDocumentsResponse = {
  data: string[];
};

export const getRemainingVerificationDocuments = async () => {
  return api.usersViewsNinjaUserVerificationListRemainingVerificationDocuments.bind(
    api
  )() as unknown as Promise<
    AxiosResponse<GetRemainingVerificationDocumentsResponse>
  >;
};

export const uploadVerificationDocument = async (
  payload: UserVerificationApiUsersViewsNinjaUserVerificationUploadVerificationDocumentRequest
) => {
  return api.usersViewsNinjaUserVerificationUploadVerificationDocument.bind(
    api
  )(payload);
};

export const uploadVerificationDocumentByThirdParty = async (
  payload: UserVerificationApiUsersViewsNinjaUserVerificationUploadVerificationDocumentByThirdPartyRequest
) => {
  return api.usersViewsNinjaUserVerificationUploadVerificationDocumentByThirdParty.bind(
    api
  )(payload);
};
